export const getFormattedIban = (iban?: string | null): string => {
  if (!iban) return '-';
  const compact = iban.replace(/\s+/g, '').toUpperCase();
  if (!compact) return '-';
  return compact.replace(/(.{4})/g, '$1 ').trim();
};
